import { createFileRoute, notFound } from "@tanstack/react-router";

import { publicShareHead } from "@/lib/share-token";

// The UUID share link, `/shared/specifications/:specType/:specUuid` (research
// §4.3, shape c): Page not found, to an anonymous visitor too. Modsy still
// mounts it, but its decode asks TIM at a path TIM does not route, so every one
// of these links lands on modsy's `*` error page today — outside every layout
// and auth gate (`SpecShareIsland.tsx`; `App.tsx:118`). The authed catch-all
// would send a stranger to sign in first instead.
export const Route = createFileRoute("/shared/specifications/$")({
  // The share pages' head too — `noindex` and the `strict-origin` referrer —
  // because a token can ride this URL as well: a retired link's.
  head: () => ({ meta: [...publicShareHead().meta, { title: "Page not found" }] }),
  loader: () => {
    throw notFound();
  },
});
